import React from 'react'; 
import Image2 from '../assets/Image2.svg';

const Argument = () => {
  
  return (
    <section className="arg-section " id="argument">
      
      <div className="arg-img-container">
        <img src={Image2} alt="Gráfico" className="max-w-full h-auto " />
      </div> 

      <div className="arg-content space-y-2">
      <div className='resp-h3 font-bold space-y-0 mb:text-center '>
        <h1 className="text-pinkmedium1">Centraliza tu documentación,  </h1>
        <h1 className="text-pink2">dinamiza tu conocimiento </h1>
        <h1 className="text-pink3">con MENTOR-IA</h1>
       
      </div>
<div className='space-y-4'>
<h1 className="arg-h4">¿Qué somos?</h1>
        <p className=" arg-p">
        Impulsado por inteligencia artificial, convierte tus documentos en conocimiento dinámico, optimizando procesos en tiempo real. 
        Ya sea para capacitación, soporte o consultoría interna, MENTOR-IA ofrece respuestas precisas y personalizadas, mejorando la eficiencia y adaptabilidad de tu organización.
        </p>
</div>
   
<a className="btn-primary" href="#contacto">Contáctanos</a>
      </div>
      
  
 
    </section>
  );
};

export default Argument;
